import { createRouter, createWebHistory } from "vue-router";
import Landing from "../views/Landing.vue";
import { useOrgStore } from "@/stores/org";

// Dedicated-org deployments compile VITE_ORG_SLUG in and keep today's flat
// paths. Shared deployments leave it empty, so every org-facing route gains
// a leading :orgSlug segment resolved at runtime instead.
const envOrgSlug = (import.meta.env.VITE_ORG_SLUG as string | undefined) || "";
const orgPrefix = envOrgSlug ? "" : "/:orgSlug";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/about",
      name: "about",
      component: () => import("../views/AboutView.vue"),
    },
    {
      // Phase 7.6: the conversion-focused marketing landing is now the root.
      // Org-agnostic in both dedicated and shared mode — never gets the
      // :orgSlug prefix.
      path: "/",
      name: "Landing",
      component: Landing,
    },
    {
      // The previous "Segera Hadir" teaser is preserved here, not deleted.
      // Safe to remove once the new Landing is confirmed in production.
      path: "/home",
      name: "HomeView",
      component: () => import("../views/HomeView.vue"),
    },
    {
      // path: "/" + COMITTEE_URL,
      path: `${orgPrefix}/registerPanitiaCYR2023`,
      name: "comitteeRegister",
      component: () => import("@/views/Event/EventRegister.vue"),
    },
    {
      path: `${orgPrefix}/eventThankYou`,
      name: "eventThankYou",
      component: () => import("@/views/Event/EventThank.vue"),
    },
    {
      path: `${orgPrefix}/thankYouPayment`,
      name: "thankYouPayment",
      component: () => import("@/views/Event/EventThank.vue"),
    },
    {
      path: `${orgPrefix}/registerCard/:id/:uid`,
      name: "registerCard",
      component: () => import("@/views/Event/ParticipantQRCard.vue"),
    },
    {
      path: `${orgPrefix}/events`,
      name: "EventList",
      component: () => import("@/views/Event/EventList.vue"),
    },
    {
      path: `${orgPrefix}/register`,
      name: "eventRegisterSlug",
      component: () => import("@/views/Event/EventRegister.vue"),
    },
    {
      path: `${orgPrefix}/uploadBukti`,
      name: "uploadBukti",
      component: () => import("@/views/Event/UploadBukti.vue"),
    },
    {
      path: "/terms",
      name: "Terms",
      component: () => import("@/views/TermsOfService.vue"),
    },
    {
      path: "/privacy",
      name: "Privacy",
      component: () => import("@/views/PrivacyPolicy.vue"),
    },
  ],
});

router.beforeEach((to) => {
  // In shared mode, mirror the resolved :orgSlug into the store so
  // components can read org context without touching route params directly.
  if (!envOrgSlug) {
    useOrgStore().setRouteOrgSlug((to.params.orgSlug as string) || "");
  }
});

router.onError((error, to) => {
  const isDynamicImportError =
    error.message.includes("Failed to fetch dynamically imported module") ||
    error.message.includes("Importing a module script failed") ||
    error.message.includes("error loading dynamically imported module");

  if (isDynamicImportError) {
    window.location.href = to.fullPath;
  }
});

export default router;
